import _ from 'underscore';
import { AriaListener } from '@bingads-webui/aria-listener';
import { Instrumentation } from '@bingads-webui/instrumentation';
import { PerformanceTimingLogger } from '@bingads-webui/performance-timing-logger';
import {
  getAriaConfig,
  PerformanceLogsFilter,
  PerformanceLogsFormatter,
  ContextProcessor,
  DebugProcessor,
  PerfTimingProcessor,
} from '@bingads-webui-campaign/instrumentation';

export const initPerfTiming = ({ pageContext, config }) => {
  const getListeners = () => {
    const ariaConfig = getAriaConfig();
    const currentEnv = _.find(_.keys(ariaConfig.tokens), env => document.domain.indexOf(env) > -1);

    // init log formatters
    const performanceLogsFormatter = new PerformanceLogsFormatter();

    // init log filters
    const performanceLogsFilter = new PerformanceLogsFilter();

    const ariaListener = new AriaListener({
      tenantToken: ariaConfig.tokens[currentEnv],
      flushInterval: ariaConfig.flushInterval,
      batchSize: ariaConfig.batchSize,
      logTableNames: {
        resourcetiming: {
          name: 'resourcetiming',
        },
      },
      defaultLogCategory: 'resourcetiming',
      formatters: {
        performanceLogsFormatter,
      },
      filters: {
        performanceLogsFilter,
      },
    });

    ariaListener.init();
    ariaListener.registerForTeardown();

    const listeners = {
      ariaListener,
    };

    return listeners;
  };

  const getProcessors = () => {
    const contextProcessor = new ContextProcessor({ pageContext });
    const debugProcessor = new DebugProcessor({
      isDebugMode: (config && config.get('isDebugMode')) || window.BINGADS_DEBUG,
    });
    const perfTimingProcessor = new PerfTimingProcessor({
      landingPageUrl: config.get('LandingPageUrl') || '',
    });

    const processors = {
      contextProcessor,
      debugProcessor,
      perfTimingProcessor,
    };

    return processors;
  };

  const instr = new Instrumentation({
    listeners: getListeners(),
    processors: getProcessors(),
  });

  const perfTimingLogger = new PerformanceTimingLogger({ instrumentation: instr });

  return {
    perfTimingLogger,
    getListeners,
    getProcessors,
  };
};
